import PropTypes from "prop-types"
import { Toolbar, Typography, IconButton } from "@mui/material"
import Tooltip from "components/material/tooltip"
import { Delete, Add } from "@mui/icons-material"
import { toLower, replace } from "lodash"
import Filters from "./filters"

// [TODO] addHidden is temporary since I need to temporarily HIDE the add button from non super-users
export default function TableToolbar({ title, addDisabled, addDisabledText, addHidden, numSelected, onClickDelete, onClickAdd, actions, filters, filterForm }) {
  const classNameSection = replace(toLower(title), /\s/g, "-")

  let computedTitle = `Add ${toLower(title)}`
  if (addDisabled) {
    if (addDisabledText) {
      computedTitle = addDisabledText
    } else {
      computedTitle = `You are not authorized to create ${toLower(title)}`
    }
  }

  if (numSelected > 0) {
    return (
      <Toolbar className="toolbar active" color="primary">
        <Typography
          variant="subtitle1"
          component="div"
          sx={{
          color: "inherit",
        }}
        >
          {numSelected} selected
        </Typography>
        <Tooltip title="Delete">
          <IconButton
            className={`delete-${classNameSection}`}
            onClick={() => onClickDelete()}
            size="large"
          >
            <Delete />
          </IconButton>
        </Tooltip>
      </Toolbar>
    )
  } else {
    const addButtonProps = {
      disabled: addDisabled,
      className: `add-button add-${classNameSection}`,
      // required because we reactivate mouse events to display toolip
      onClick: addDisabled ? undefined : onClickAdd,
      // required to display toolip on disabled button
      component: addDisabled ? "div" : undefined,
      color: "primary",
    }

    return <Toolbar className="toolbar" color="primary">
      <Typography variant="h6" id="tableTitle" component="div">
        {title}
      </Typography>
      {actions}
      {filterForm && <Filters filters={filters} filterForm={filterForm} />}
      { !addHidden && <Tooltip title={computedTitle}>
        <IconButton {...addButtonProps} size="large">
          <Add />
        </IconButton>
      </Tooltip> }
    </Toolbar>
  }
}

TableToolbar.propTypes = {
  title: PropTypes.string.isRequired,
  addDisabled: PropTypes.bool.isRequired,
  addDisabledText: PropTypes.string,
  addHidden: PropTypes.bool.isRequired,
  numSelected: PropTypes.number.isRequired,
  onClickDelete: PropTypes.func.isRequired,
  onClickAdd: PropTypes.func.isRequired,
  actions: PropTypes.node,
  filters: PropTypes.arrayOf(PropTypes.func),
  filterForm: PropTypes.node,
}
